import React, { useState } from 'react';
import EmailSettings from './EmailSettings';
import LushaSettings from '../components/integrations/LushaSettings';
import RocketReachSettings from '../components/integrations/RocketReachSettings';
import ClaudeSettings from '../components/integrations/ClaudeSettings';

/**
 * Integrations — single home for every external-service config.
 *
 * Each integration is a tab. The tabs live as separate components under
 * client/components/integrations/* so adding a new one (Slack, Salesforce,
 * Stripe, …) is a one-file drop-in:
 *   1. Create components/integrations/<NewName>Settings.jsx
 *   2. Append a row to TABS below
 *
 * Existing data is preserved — Email config still reads from settings.key
 * = 'email_smtp', Lusha from 'lusha', Claude from 'anthropic'. Nothing is
 * migrated. The old /admin/email URL still works as an alias for the Email
 * tab so deep links don't break.
 */

const TABS = [
  { id: 'email',        label: 'Email',              description: 'Outbound mail relay (SMTP / Microsoft Graph)', component: EmailSettings },
  { id: 'lusha',        label: 'Lusha',              description: 'Contact enrichment for leads',                 component: LushaSettings },
  { id: 'rocketreach',  label: 'RocketReach',        description: 'Contact enrichment + email finder',            component: RocketReachSettings },
  { id: 'claude',       label: 'Claude (Anthropic)', description: 'API key for AI features',                      component: ClaudeSettings },
];

export default function Integrations({ currentUser, initialTab }) {
  const [tab, setTab] = useState(initialTab && TABS.find(t => t.id === initialTab) ? initialTab : 'email');
  const Active = (TABS.find(t => t.id === tab) || TABS[0]).component;

  return (
    <div style={{ padding: 20, maxWidth: 1100, margin: '0 auto' }}>
      <div style={{ marginBottom: 12 }}>
        <h1 style={{ margin: 0, fontSize: 18 }}>Integrations</h1>
        <div style={{ color: '#94A3B8', fontSize: 12.5, marginTop: 4 }}>
          External services BizSuite talks to. Add API keys here, test them, and BizSuite will use them across the app.
        </div>
      </div>

      {/* Tab strip */}
      <div style={{ display: 'flex', gap: 4, borderBottom: '1px solid rgba(255,255,255,0.08)', marginBottom: 18, flexWrap: 'wrap' }}>
        {TABS.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)} style={{
            padding: '10px 16px', border: 'none', background: 'transparent', cursor: 'pointer',
            color: tab === t.id ? '#6FE6FF' : '#94A3B8',
            borderBottom: tab === t.id ? '2px solid #00E0FF' : '2px solid transparent',
            fontSize: 13, fontWeight: 600,
          }}>{t.label}</button>
        ))}
      </div>

      {/* Active tab */}
      <Active currentUser={currentUser} />
    </div>
  );
}
